import actions from "./actions";

const initState = {
  giftInfo: {},
  gifts: {
    data: [],
  },
  loading: false,
  giftDeleted: false,
};

export default function fetchGiftsReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_GIFTS_REQUESTED:
    case actions.SEARCH_GIFT_REQUESTED:
      return {
        ...state,
        gifts: {
          data: [],
        },
        giftInfo: {},
        loading: true,
      };
    case actions.FETCH_GIFTS_SUCCEEDED:
    case actions.SEARCH_GIFT_SUCCEEDED:
      return {
        ...state,
        gifts: action.gifts,
        loading: false,
      };
    case actions.FETCH_GIFTS_FAILED:
    case actions.SEARCH_GIFT_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.FETCH_GIFT_REQUESTED:
      return {
        ...state,
        giftInfo: {},
        loading: true,
      };
    case actions.FETCH_GIFT_SUCCEEDED:
      return {
        ...state,
        giftInfo: action.gift,
        loading: false,
      };
    case actions.FETCH_GIFT_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.DELETE_GIFT_REQUESTED:
      return {
        ...state,
        loading: true,
        giftDeleted: false,
      };
    case actions.DELETE_GIFT_SUCCEEDED:
      return {
        ...state,
        loading: false,
        giftDeleted: true,
      };
    case actions.DELETE_GIFT_FAILED:
      return {
        ...state,
        loading: false,
        giftDeleted: false,
      };
    default:
      return state;
  }
}
